<template>
  <div
    :class="[
      isMobile
        ? 'mobile-card-line +pd-top-xs +pd-bottom-xs +pd-left-sm +pd-right-sm'
        : 'size-1of5',
      'grid-cell'
    ]"
  >
    <div
      v-if="isMobile"
      class="grid --with-gutter --align-middle --equal-height"
    >
      <div class="grid-cell size-3of12">
        <img
          :src="card.image"
          :title="card.name"
          :alt="card.name"
          style="max-height: 42px; max-width: 63px;"
        />
      </div>
      <div class="grid-cell size-8of12 +text-size-xs +leading-tight">
        {{ card.name }}
      </div>
      <div class="grid-cell size-1of12 +text-right">
        <button
          @click="clearCard"
          class="mobile-close-card button --bare --bare-button"
        >
          <span class="icon --sm +fill-gray">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 320 512"
              class="icon__glyph"
            >
              <path
                fill="currentColor"
                d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z"
                class=""
              ></path>
            </svg>
          </span>
        </button>
      </div>
    </div>
    <div v-else class="+display-flex--md +justify-content-center">
      <span class="card-box-container">
        <tooltip force-hover position="bottom-center" :content="card.name">
          <img
            :src="card.image"
            :title="card.name"
            :alt="card.name"
            style="max-height: 50px;"
          />
        </tooltip>
        <button
          @click="clearCard"
          class="+bg-blue button-card-close +fg-white +border"
        >
          <span class="icon --xs +fg-white">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 320 512"
              class="icon__glyph"
            >
              <path
                fill="currentColor"
                d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z"
                class=""
              ></path>
            </svg>
          </span>
        </button>
      </span>
    </div>
  </div>
</template>

<script>
import tagularModule from 'js/store/helpers/tagular'
import utilities from 'apps/utility/vue-common'
import { Tooltip } from '@bankrate/vue-components'

export default {
  components: {
    Tooltip
  },
  props: {
    card: {
      type: Object
    }
  },
  computed: {
    isMobile() {
      return utilities.methods.isMobile()
    }
  },
  methods: {
    clearCard() {
      this.$store.dispatch('removeCard', { slug: this.card.slug })

      tagularModule.elementClicked({
        location: 'Compare',
        position: 'Footer',
        elementType: 'Button',
        text: 'X',
        htmlId: ''
      })
    }
  }
}
</script>

<!-- eslint-disable -->

<style lang="scss">
@import './../../../../sass/brcom/settings/_settings.theme-colors.scss';

.card-box-container {
  display: inline-block;
  position: relative;
  margin: 0 6px;
}
.card-box-container .tooltip .\+pd-bottom-xxs,
.card-box-container .tooltip .\+pd-bottom-xs {
  padding-bottom: 0px !important;
}
.card-box-container .tooltip .tooltip__box {
  top: 1.5rem;
  min-width: auto;
  width: auto;
}
.card-box-container .tooltip .tooltip__copy {
  text-align: center;
  white-space: nowrap;
  font-size: 0.77777778rem;
  line-height: 1.5;
}
.button-card-close {
  position: absolute;
  top: -12px;
  right: -12px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.mobile-close-card {
  height: 36px;
  width: 36px;
  padding: 0;
}
.mobile-close-card svg {
  width: 22px;
  height: 22px;
  color: $theme-gray;
}
.mobile-card-line {
  border-bottom: 1px solid $theme-gray-lighter;
}
.mobile-card-line:first-child {
    border-top: 1px solid $theme-gray-darker;
}
.mobile-card-line:last-child {
  border: 0;
}
</style>
<!-- eslint-enable -->
